import { createApi } from '@reduxjs/toolkit/query/react'
import { MDT_TERMS_ADD, MDT_TERMS_DELETE, MDT_TERMS_EDIT, MDT_TERMS_LISTING, MDT_TERMS_VIEW } from "config/apiPaths"
import axiosBaseQuery from "utils/axios/axiosBaseQuery"

export const mdtTermsApi = createApi({
    reducerPath: 'mdtTermsApi',
    baseQuery: axiosBaseQuery({
        baseUrl: "/mdt/terms",
    }),
    tagTypes: ["mdtTermsList", "mdtTermDetails"],
    endpoints: (builder) => ({

        // get mdt terms list
        getMdtTermsList: builder.query({
            query: ({ search = "", status = "", page = 1, limit = 10, sort = { column: "id", direction: "ASC" } }) => ({
                method: "PATCH",
                url: MDT_TERMS_LISTING,
                data: { search, status, page, limit, sort }
            }),

            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["mdtTermsList"]
        }),

        // add new MDT status
        addMdtTerms: builder.mutation({
            query: (data) => ({
                method: "POST",
                url: MDT_TERMS_ADD,
                data
            }),
            invalidatesTags: ["mdtTermsList"]
        }),

        // update MDT terms
        updateMdtTerms: builder.mutation({
            query: ({ id, data }) => ({
                method: "PUT",
                url: `${MDT_TERMS_EDIT}/${id}`,
                data
            }),
            invalidatesTags: ["mdtTermsList"]
        }),

        // MDT term details
        mdtTermDetails: builder.query({
            query: (id) => ({
                method: "GET",
                url: `${MDT_TERMS_VIEW}/${id}`

            }),
            transformResponse: (response) => {
                return response.data;
            },
            providesTags: ["mdtTermDetails"]
        }),

        // MDT status delete
        mdtTermsDelete: builder.mutation({
            query: (id) => ({
                method: "DELETE",
                url: `${MDT_TERMS_DELETE}/${id}`
            }),
            invalidatesTags: ["mdtTermDetails", "mdtTermsList"]
        })
    }),
})

export const {
    useGetMdtTermsListQuery,
    useAddMdtTermsMutation,
    useUpdateMdtTermsMutation,
    useMdtTermDetailsQuery,
    useMdtTermsDeleteMutation

} = mdtTermsApi;